import React from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Collapse,
  IconButton,
  Typography
} from '@mui/material';
import {
  Close as CloseIcon,
  PauseCircle as PauseCircleIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useActivitySuspension } from '../../hooks/useActivitySuspension';

/**
 * Bannière affichée sur toutes les pages quand l'utilisateur a suspendu
 * volontairement son activité.
 */
const ActivitySuspensionBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { loading, isSuspended, listingsDeactivated, productsDeactivated } = useActivitySuspension();
  const [open, setOpen] = React.useState(true);

  if (loading || !isSuspended || !open) {
    return null;
  }

  return (
    <Collapse in={open}>
      <Alert
        severity="warning"
        icon={<PauseCircleIcon />}
        sx={{ borderRadius: 0, borderBottom: '1px solid', borderColor: 'warning.light' }}
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              size="small"
              color="warning"
              variant="outlined"
              onClick={() => navigate('/activity-suspension')}
              sx={{ whiteSpace: 'nowrap' }}
            >
              {t('activitySuspension.banner.manageButton')}
            </Button>
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setOpen(false)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
        }
      >
        <AlertTitle>
          {t('activitySuspension.banner.title')}
        </AlertTitle>
        <Typography variant="body2">
          {t(
            'activitySuspension.banner.message',
            {
              listings: listingsDeactivated,
              products: productsDeactivated
            }
          )}
        </Typography>
      </Alert>
    </Collapse>
  );
};

export default ActivitySuspensionBanner;
